import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import colors from '../../../../../constants/colors';

const useStyles = makeStyles(() => ({
  root: {
    margin: '0 14px',
  },
  title: {
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    color: colors.blue,
    marginTop: '8px',
    marginBottom: '6px',
    fontSize: '1.6rem',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    marginBottom: '6px',
    flexWrap: 'wrap',
    gap: '4px',
  },
  box: {
    fontSize: '1.4rem',
    fontWeight: '600',
    lineHeight: '120%',
    height: '33px',
    paddingLeft: '5px',
    paddingRight: '5px',
    minWidth: '81px',
    alignItems: 'center',
    background: 'linear-gradient(135deg, #e8f7fc 0%, #cdf0f8 100%)',
    border: '1px solid #a0d8ef',
    borderRadius: '4px',
    color: '#2a3a42',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    marginRight: '4px',
    transition: 'all 0.2s ease',
    '&:hover': {
      background: 'linear-gradient(135deg, #c8eef8 0%, #a0e0f5 100%)',
      color: '#1a5fa8',
    },
  },
  boxActive: {
    fontSize: '1.4rem',
    fontWeight: '600',
    lineHeight: '120%',
    minWidth: '81px',
    height: '33px',
    paddingLeft: '5px',
    paddingRight: '5px',
    alignItems: 'center',
    background: 'linear-gradient(135deg, #00d5fd 0%, #0495ff 50%, #0072ee 100%)',
    border: '1px solid transparent',
    borderRadius: '4px',
    boxShadow: '0 2px 8px rgba(0, 180, 220, 0.3)',
    color: colors.white,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    marginRight: '4px',
    transition: 'all 0.2s ease',
  }
}));

const Filters = ({ onFilterClick }) => {
  const tabs = [
    {
      name: 'ACD',
    },
    {
      name: 'Schedule',
    },
  ];
  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const classes = useStyles('');

  const handleSelectedTab = (tab) => {
    setSelectedTab(tab);
  };

  useEffect(() => {
    onFilterClick(selectedTab.name);
  }, [selectedTab]);

  return (
    <Box className={classes.root}>
      <Box className={classes.title}>
        Filters
      </Box>
      <Box className={classes.row}>
        {tabs.map((tab) => (
          <Box
            className={
              selectedTab.name === tab.name
                ? classes.boxActive : classes.box
            }
            key={tab.name}
            onClick={() => handleSelectedTab(tab)}
          >
            {tab.name}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

Filters.propTypes = {
  onFilterClick: PropTypes.func.isRequired,
};

export default Filters;
